import PropTypes from 'prop-types';
import environment from 'platform/utilities/environment';
import { useBrowserMonitoring } from 'platform/monitoring/Datadog';

import manifest from '../manifest.json';
import { datadogBeforeSend, sessionReplaySampleRate } from '../utils/datadog';

/**
 * Root VASS wrapper that initializes Datadog RUM and Browser Logs for every
 * schedule and cancel route. Config (applicationId, clientToken, toggle,
 * privacy level, replay rate) comes from the manifest `datadog` block.
 * Staging passes a replay rate of 100. Other environments pass the manifest
 * rate.
 */
const App = ({ children }) => {
  useBrowserMonitoring({
    service: 'vass',
    beforeSend: datadogBeforeSend,
    sessionReplaySampleRate: sessionReplaySampleRate(
      environment.vspEnvironment(),
      manifest.datadog.sessionReplaySampleRate,
    ),
  });

  return children;
};

App.propTypes = {
  children: PropTypes.node,
};

export default App;
